export default {
  CHECKOUT: 'CHECKOUT',
  COMPLETE: 'COMPLETE',
  PROCESSING: 'PROCESSING',
  PAYMENT_CHANGE: 'PAYMENT_CHANGE',
  PAYMENT_CHANGED: 'PAYMENT_CHANGED',
  PAYMENT_RESOLUTION: 'PAYMENT_RESOLUTION',
  PAYMENT_RESOLVED: 'PAYMENT_RESOLVED',
};
